import type { CSSObject } from "@emotion/react";

export const rootCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  position: "relative",
  width: "100%",
  maxWidth: "720px",
  zIndex: "2",
  alignItems: "baseline",
  listStyleType: "none",
  padding: 0,
  marginBottom: "48px",
  gap: "32px",
};
